import { CheckoutEvents } from '@mc/pre-paywall-events'
import { track, getPageSource } from '@mc/track-event'
import { Location, Vendor } from './data'

export const trackFlyoutContinueClicked = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN_INITIATED, {
    action: 'continue',
    location: Location.FLYOUT,
    page_source: getPageSource(),
    social_sign_on_vendor: Vendor.GOOGLE,
  })
}
